import { SerializeOptions } from 'cookie';
import { parseCookies, setCookie, destroyCookie } from 'nookies';
import { ServerSideProps } from 'core/funnel/entities';
import { CookiesService } from './CookiesService';

export class CookiesServerService implements CookiesService {
  private options: SerializeOptions;
  private serverContext?: ServerSideProps;

  constructor(options: SerializeOptions = {}, serverContext?: ServerSideProps) {
    this.options = options;
    this.serverContext = serverContext;
  }

  set(key: string, value: string, options: SerializeOptions = {}) {
    if (!this.serverContext) return;

    const mergedOptions = { ...this.options, ...options };
    setCookie(this.serverContext, key, value, mergedOptions);
  }

  get(key: string): string | undefined {
    if (!this.serverContext) return;

    const cookies = parseCookies(this.serverContext);
    return cookies[key];
  }

  getAll(): Record<string, string> | undefined {
    if (!this.serverContext) return;

    return parseCookies(this.serverContext);
  }

  remove(key: string, options: SerializeOptions = {}) {
    if (!this.serverContext) return;

    const mergedOptions = { ...this.options, ...options };
    destroyCookie(this.serverContext, key, mergedOptions);
  }
}
